import { useEffect } from 'react';
import type { LocationSensorState } from 'react-use/lib/useLocation';

import { useTourStore } from '@revelio/core';

export const useTutorialLinkHandler = (location: LocationSensorState) => {
  const setVideoId = useTourStore((s) => s.setVideoId);
  const setIsVideoOpen = useTourStore((s) => s.setIsVideoOpen);

  // biome-ignore lint/correctness/useExhaustiveDependencies: migrated from develop
  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const videoId = urlParams.get('vtid');

    if (videoId) {
      setVideoId(videoId);
      setIsVideoOpen(true);
    }
  }, []);
};
